/**
 * Kullanıcıya gösterilecek hatalar için kod tabanlı hata tipi.
 * UI, kodu sözlükten çevirir; ham mesaj yalnızca ayrıntı olarak eklenir.
 */
export class RepError extends Error {
	code: string;
	params?: Record<string, string | number>;

	constructor(code: string, params?: Record<string, string | number>) {
		super(code);
		this.name = 'RepError';
		this.code = code;
		this.params = params;
	}
}

export function toRepError(err: unknown): RepError {
	if (err instanceof RepError) return err;
	const message = err instanceof Error ? err.message : String(err);
	return new RepError('err.generic', { message });
}
